import { components } from "@certn/api/generated-schemas/applicant-portal";
import {
  ActionList,
  Checkbox,
  Divider,
  mq,
  Stack,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import { ConsentActionListItem } from "./ConsentActionListItem";

interface Props {
  consents: components["schemas"]["ApplicantAgreementTemplate"][];
  isSigned: boolean;
  onChange: () => unknown;
}

export function ListViewConsents(props: Props) {
  const { consents, isSigned, onChange } = props;

  const { t } = useTranslation();

  return (
    <Stack gap="space-4">
      <ActionList
        children={
          <>
            {consents.map((consent) => {
              return (
                <Fragment key={consent.id || consent.external_id}>
                  <ConsentActionListItem consent={consent} />
                  <Divider />
                </Fragment>
              );
            })}
            <footer className={css(styles.footer)}>
              <Checkbox
                isSelected={isSigned}
                onChange={onChange}
                testID="contract-scroll"
              >
                {t(
                  "I acknowledge and confirm that I have been provided with and reviewed a copy of all the documents listed above"
                )}
              </Checkbox>
            </footer>
          </>
        }
      />
    </Stack>
  );
}

const styles = {
  footer: css(
    mq({
      padding: [
        `${"var(--space-2)"} ${"var(--space-4)"}`,
        `${"var(--space-2)"} ${"var(--space-4)"}`,
      ],
      textAlign: "left",
    })
  ),
};
